<fury-page-layout mode="card">
  <fury-page-layout-header>
    <fury-breadcrumbs [@fadeInRight]  current="Checkout Settings"></fury-breadcrumbs>
  </fury-page-layout-header>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">

          <form [formGroup]="checkoutSettingsForm" style="width: 100%;">
            <div class="content" fxLayout="column" fxLayoutGap="8px">
                <div  formGroupName="installmentLimits">
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    <mat-form-field appearance="outline" fxFlex="auto">
                      <mat-label>Annually Plan Installment Limit</mat-label>
                      <input matInput placeholder="Annually Plan Installment Limit" formControlName="annuallyPlanInstallmentLimit" mask="0" thousandSeparator="," min="1"/>
                      <mat-error *ngIf="checkoutSettingsForm.get('installmentLimits.annuallyPlanInstallmentLimit').hasError('required') && checkoutSettingsForm.get('installmentLimits.annuallyPlanInstallmentLimit'
                      )!.touched
                    ">
                    This field is required.
                  </mat-error>
                  <mat-error *ngIf="checkoutSettingsForm.get('installmentLimits.annuallyPlanInstallmentLimit').hasError('min') && checkoutSettingsForm.get('installmentLimits.annuallyPlanInstallmentLimit'
                      )!.touched
                    ">
                   Minimum Value should be 1.
                  </mat-error>
                  <mat-error *ngIf="checkoutSettingsForm.get('installmentLimits.annuallyPlanInstallmentLimit').hasError('max') && checkoutSettingsForm.get('installmentLimits.annuallyPlanInstallmentLimit'
                      )!.touched
                    ">
                   Maximum Value should be 9.
                  </mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" fxFlex="auto">
                      <mat-label>Two Years Plan Installment Limit</mat-label>
                      <input matInput placeholder="Two Years Plan Installment Limit" formControlName="twoYearsPlanIInstallmentLimit" mask="0" thousandSeparator="," min="1"/>
                      <mat-error *ngIf="checkoutSettingsForm.get('installmentLimits.twoYearsPlanIInstallmentLimit').hasError('required') && checkoutSettingsForm.get('installmentLimits.twoYearsPlanIInstallmentLimit'
                      )!.touched
                    ">
                    This field is required.
                  </mat-error>
                  <mat-error *ngIf="checkoutSettingsForm.get('installmentLimits.twoYearsPlanIInstallmentLimit').hasError('min') && checkoutSettingsForm.get('installmentLimits.twoYearsPlanIInstallmentLimit'
                      )!.touched
                    ">
                   Minimum Value should be 1.
                  </mat-error>
                  <mat-error *ngIf="checkoutSettingsForm.get('installmentLimits.twoYearsPlanIInstallmentLimit').hasError('max') && checkoutSettingsForm.get('installmentLimits.twoYearsPlanIInstallmentLimit'
                      )!.touched
                    ">
                   Maximum Value should be 9.
                  </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                    
                      <mat-form-field appearance="outline" fxFlex="auto">
                        <mat-label>Three Years Plan Installment Limit</mat-label>
                        <input matInput placeholder="Three Years Plan Installment Limit" formControlName="threeYearsPlanIInstallmentLimit" mask="0" thousandSeparator="," min="1"/>
                        <mat-error *ngIf="checkoutSettingsForm.get('installmentLimits.threeYearsPlanIInstallmentLimit').hasError('required') && checkoutSettingsForm.get('installmentLimits.threeYearsPlanIInstallmentLimit'
                        )!.touched
                      ">
                      This field is required.
                    </mat-error>
                    <mat-error *ngIf="checkoutSettingsForm.get('installmentLimits.threeYearsPlanIInstallmentLimit').hasError('min') && checkoutSettingsForm.get('installmentLimits.threeYearsPlanIInstallmentLimit'
                        )!.touched
                      ">
                     Minimum Value should be 1.
                    </mat-error>
                    <mat-error *ngIf="checkoutSettingsForm.get('installmentLimits.threeYearsPlanIInstallmentLimit').hasError('max') && checkoutSettingsForm.get('installmentLimits.threeYearsPlanIInstallmentLimit'
                        )!.touched
                      ">
                     Maximum Value should be 9.
                    </mat-error>
                      </mat-form-field>
                  
                   
                        <mat-form-field appearance="outline" fxFlex="auto">
                          <mat-label>Four Years Plan Installment Limit</mat-label>
                          <input matInput placeholder="Four Years Plan Installment Limit" formControlName="fourYearsPlanIInstallmentLimit" mask="0" thousandSeparator="," min="1"/>
                          <mat-error *ngIf="checkoutSettingsForm.get('installmentLimits.fourYearsPlanIInstallmentLimit').hasError('required') && checkoutSettingsForm.get('installmentLimits.fourYearsPlanIInstallmentLimit'
                          )!.touched
                        ">
                        This field is required.
                      </mat-error>
                      <mat-error *ngIf="checkoutSettingsForm.get('installmentLimits.fourYearsPlanIInstallmentLimit').hasError('min') && checkoutSettingsForm.get('installmentLimits.fourYearsPlanIInstallmentLimit'
                          )!.touched
                        ">
                      Minimum Value should be 1.
                      </mat-error>
                      <mat-error *ngIf="checkoutSettingsForm.get('installmentLimits.fourYearsPlanIInstallmentLimit').hasError('max') && checkoutSettingsForm.get('installmentLimits.fourYearsPlanIInstallmentLimit'
                          )!.touched
                        ">
                      Maximum Value should be 9.
                      </mat-error>
                        </mat-form-field>
                        
                          <mat-form-field appearance="outline" fxFlex="auto">
                            <mat-label>Five Years Plan Installment Limit</mat-label>
                            <input matInput placeholder="Five Years Plan Installment Limit" formControlName="fiveYearsPlanIInstallmentLimit" mask="0" thousandSeparator="," min="1"/>
                            <mat-error *ngIf="checkoutSettingsForm.get('installmentLimits.fiveYearsPlanIInstallmentLimit').hasError('required') && checkoutSettingsForm.get('installmentLimits.fiveYearsPlanIInstallmentLimit'
                            )!.touched
                          ">
                          This field is required.
                        </mat-error>
                        <mat-error *ngIf="checkoutSettingsForm.get('installmentLimits.fiveYearsPlanIInstallmentLimit').hasError('min') && checkoutSettingsForm.get('installmentLimits.fiveYearsPlanIInstallmentLimit'
                            )!.touched
                          ">
                         Minimum Value should be 1.
                        </mat-error>
                        <mat-error *ngIf="checkoutSettingsForm.get('installmentLimits.fiveYearsPlanIInstallmentLimit').hasError('max') && checkoutSettingsForm.get('installmentLimits.fiveYearsPlanIInstallmentLimit'
                            )!.touched
                          ">
                         Maximum Value should be 9.
                        </mat-error>
                          </mat-form-field>
                  </div>
                    
                </div>
                <div class="toggle-parents">
                  <div>
                    <mat-slide-toggle formControlName="bankingPaymentStatus">Banking Payment</mat-slide-toggle>
                  </div>
                  <div>
                    <mat-slide-toggle formControlName="onFrontendCheckout">Enable Checkout (Frontend)</mat-slide-toggle>
                  </div>
                </div>
            </div>
            <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
              <button mat-button type="button" class="sub-button" (click)="update()"><span>Update</span></button>
              <button mat-button type="button" class="can-button" (click)="location.back()"><span>Back</span></button>
            </div>
          </form>
    </div>
  </div>
</fury-page-layout>